import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/learn/saint-tms-near-me")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "saint-tms-locations" },
      replace: true,
    });
  },
});
